import { Box, Center, Spinner } from '@chakra-ui/react';
import { useGetStatisticsQuery } from 'core/API/sharedApi';
import { useGetAuthorizedTabsSelector } from 'core/redux/selectors/authSelectors';
import { useTranslation } from 'helpers/languages/translations';
import PageHeader from 'layout/pageHeader';
import { entries } from 'utils/wrappers';

import MPageStatisticsReviewSection from './components/molecules/MPageStatisticsReviewSection';
import { statsCards, statsSections } from './const';
import { IStatistics, Tcard } from './types';

const PATH = 'home';
const ID = 'home';
const NAME = 'page.home';

const Home = () => {
    const { authorizedTabs } = useGetAuthorizedTabsSelector();
    const { data, isLoading } = useGetStatisticsQuery(authorizedTabs);
    const translate = useTranslation();

    const renderAuthorizedStatistics = (statistics: IStatistics) => {
        return (
            <Box>
                {entries(statistics)
                    .sort(([key1], [key2]) => statsSections[key1].order - statsSections[key2].order)
                    .map(([key, statisticByType]) => {
                        const cards: Tcard[] = [];
                        entries(statisticByType).forEach(([statKey, stat]) => {
                            if (statsCards[key][statKey].multiple) {
                                entries(stat).forEach(([statType, val]) => {
                                    const card = {
                                        title: translate(statsCards[key][statKey].title, { lang: statType }) as string,
                                        value: val,
                                        path: statsCards[key][statKey].path,
                                        ...(statsCards[key][statKey].link
                                            ? { link: statsCards[key][statKey].link }
                                            : {}),
                                    };
                                    cards.push(card);
                                });
                            } else {
                                const card = {
                                    title: translate(statsCards[key][statKey].title) as string,
                                    value: Array.isArray(stat) ? stat.length : stat,
                                    path: statsCards[key][statKey].path,
                                    ...(statsCards[key][statKey].link ? { link: statsCards[key][statKey].link } : {}),
                                };
                                cards.push(card);
                            }
                        });

                        return (
                            <MPageStatisticsReviewSection
                                key={statsSections[key].title}
                                icon={statsSections[key].icon}
                                title={translate(statsSections[key].title) as string}
                                cards={cards}
                            />
                        );
                    })}
            </Box>
        );
    };

    return (
        <Box h="100%">
            <PageHeader icon={{ name: 'home' }} pageTitle={translate('page.home') as string} />
            {isLoading && (
                <Center mt="220px" flexGrow="1">
                    <Spinner speed="0.65s" emptyColor="gray.200" color="blueMain" size="xl" />
                </Center>
            )}
            {!isLoading && data && renderAuthorizedStatistics(data.statistics)}
        </Box>
    );
};

export { PATH, ID, NAME };
export default Home;
